import React from 'react'
import Head from 'next/head'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Layout from '../../src/components/General/Layout'
import Terms from '../../src/components/Sections/Terms'

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5),
    },
}))

const TermsPage = () => {
    const classes = useStyles()
    return (
        <Layout>
            <Head>
                <title>
                    Terms of Use | Mase Rasti Team - Your trusted realtor!
                </title>
                <meta
                    name="description"
                    content="Terms of Use - Mase Rasti Team Real Estate"
                />
            </Head>
            <Container className={classes.container}>
                <Terms />
            </Container>
        </Layout>
    )
}

export default TermsPage
